import PdfPreview from "./containers/invoices/main";
//import PdfPrint from "./containers/invoices/pdfPrint";
import "./App.css";
import Invoices from "./containers/invoices/invoices";
import Packinglist from "./containers/invoices/packinglist";
import Readxl from "./containers/invoices/readxl";
// import Test from "./containers/draft/test";

function App() {
   return <Invoices />
  //return <Packinglist/>
  //return <PdfPreview/>
}

export default App;
